import React from 'react';
import ButtonsStyle from './style';
import { Link } from 'react-router-dom';

export default function ButtonBack({ text = 'Home', path = '/' }) {
  return (
    <ButtonsStyle>
      <Link to={path}>{text}</Link>
    </ButtonsStyle>
  );
}
